import { connect } from 'react-redux'
import  OrderTotals from '../components/order_totals'

const mapStateToProps = (state) => {
  return {
    totals: state.checkout.totals
  }
}

const OrderTotalSummary = connect(mapStateToProps)(OrderTotals);

export default OrderTotalSummary;
